import * as React from 'react';

import { ReMatterLogo, cn } from '@rematter/ui-web';

import { VerifyEmailForm } from './components/VerifyEmailForm';

export const VerifyEmail = () => (
  <div
    className={cn(
      '@VerifyEmail',
      'relative flex min-h-screen items-center justify-center overflow-hidden p-5',
      'bg-gradient-to-b from-foreground/4 to-foreground/8',
    )}
  >
    <div
      className={cn(
        'relative z-10 flex w-full max-w-[500px] flex-col rounded-xl border border-abs-white/20 bg-space p-10 shadow-2xl shadow-primary/10',
      )}
    >
      <div className="mb-6 flex justify-center">
        <ReMatterLogo size="large" height={50} />
      </div>
      <VerifyEmailForm />
    </div>
  </div>
);
